import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux"; // only for syncing
import styled from "styled-components";
import { setUser, logoutUser } from "../store/slices/authSlice";

export default function AdminRoute({ children }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const verifyAdmin = async () => {
      // 1️⃣ Read directly from sessionStorage
      const storedTokens = JSON.parse(sessionStorage.getItem("tokens") || "null");
      const storedApiKey = JSON.parse(sessionStorage.getItem("api_key") || "null");

      if (!storedTokens?.access_token || !storedApiKey?.user_api_key) {
        console.warn("AdminRoute: No tokens or API key found in sessionStorage");
        setLoading(false);
        return; // will redirect because tokens are missing
      }

      try {
        // 2️⃣ Call /info/ (without /api prefix)
        const res = await fetch("/info/", {
          headers: {
            Authorization: `Bearer ${storedTokens.access_token}`,
            User_api_key: storedApiKey.user_api_key,
          },
        });

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();
        

        // Extract user (handle both nested and direct)
        const userData = data.user || data;
        

        if (userData?.role === "admin") {
          setIsAdmin(true);
          // Sync Redux (optional, but recommended)
          dispatch(
            setUser({
              user: userData,
              access_token: storedTokens.access_token,
              refresh_token: storedTokens.refresh_token,
              user_api_key: storedApiKey.user_api_key,
            })
          );
        } else {
          console.warn("AdminRoute: User is not admin");
          setIsAdmin(false);
        }
      } catch (err) {
        console.error("Admin check failed:", err);
        // Fallback: if API fails, check if we already have user role in session?
        // We don't store role in session, so treat as non-admin.
        setIsAdmin(false);
        dispatch(logoutUser());
      } finally {
        setLoading(false);
      }
    };

    verifyAdmin();
  }, [dispatch]);

  // ⏳ Loading state
  if (loading) {
    return (
      <LoaderContainer>
        <Spinner />
        <p>Checking admin access...</p>
      </LoaderContainer>
    );
  }

  // ❌ Not authenticated → redirect to login
  const storedTokens = JSON.parse(sessionStorage.getItem("tokens") || "null");
  if (!storedTokens?.access_token) {
    return <Navigate to="/login" replace />;
  }

  // 🚫 Not admin → block access
  if (!isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  // ✅ Admin allowed
  return children;
};


const LoaderContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(135deg, #1a1a1a, #2c2c2c);
  color: white;
`;

const Spinner = styled.div`
  width: 45px;
  height: 45px;
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-top: 5px solid #ffd369;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;